export type IMaximaType = [number, number]

export const evaluateLowestAndHighest = (array: Array<number>): IMaximaType => [Math.min(...array), Math.max(...array)]
